import { IndependentLocales } from "@/locales/localeid";
import { vuexName, MODULES } from "@/store/utils";
import { notification } from "ant-design-vue";
import { computed, watch } from "vue";
import { fmtMsg } from "vue-glcommonui";
import { useStore } from "vuex";

export const useIndependentMode = () => {
  const { getters } = useStore();
  const isIndependentModeEnabled = computed(() => getters[vuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_INDEPENDENT_MODE_ENABLED)]);
  return { isIndependentModeEnabled };
};

export const useIndependentModeNotification = () => {
  const { getters } = useStore();
  const isIndependentModeEnabled = computed<boolean>(() => getters[vuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_INDEPENDENT_MODE_ENABLED)]);

  watch(isIndependentModeEnabled, (enabled) => {
    if (enabled) {
      notification.info({ message: fmtMsg(IndependentLocales.StartMessage) });
    } else {
      notification.info({ message: fmtMsg(IndependentLocales.StopMessage) });
    }
  });
};
